import { NgClass } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  input,
  output,
} from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';

export interface PendingMandatoryActionDetails {
  isWaiverRequired: boolean;
  isTokenRequired: boolean;
  mandatoryFieldsRequired: string[];
}

export interface SubscriptionData {
  is_autopay_enabled: boolean;
  pending_for_mandatory_action_details: PendingMandatoryActionDetails;
}

@Component({
  selector: 'pending-actions-popup',
  templateUrl: './pending-actions-popup.component.html',
  styleUrls: ['./pending-actions-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [DialogModule, ButtonModule, TranslateModule, NgClass],
})
export class PendingActionsPopupComponent {
  readonly visible = input<boolean>(false);
  readonly pendingDetails = input<PendingMandatoryActionDetails | null>(null);
  readonly isAutopayEnabled = input<boolean>(false);
  readonly visibleChange = output<boolean>();
  readonly closePopup = output<void>();

  onHide() {
    this.visibleChange.emit(false);
    this.visibleChange.emit(false);
    this.closePopup.emit();
  }

  onClose() {
    this.onHide();
  }

  formatFieldName(fieldName: string): string {
    // Handle specific field name mappings
    const fieldMappings: { [key: string]: string } = {
      ImageBase64: 'Image',
      DateOfBirth: 'Date Of Birth',
      SecondMobileCountryCode: 'Second Mobile Country Code',
      SecondMobileNumber: 'Second Mobile Number',
      AddressPinCode: 'Address Pin Code',
      MedicalAlert: 'Medical Alert',
      TaxNumber: 'Tax Number',
      NationalId: 'National ID',
      EmergencyContactNumber: 'Emergency Contact Number',
      EmergencyContactPerson: 'Emergency Contact Person',
    };

    // Check if we have a specific mapping for this field
    if (fieldMappings[fieldName]) {
      return fieldMappings[fieldName];
    }

    // Fallback to generic formatting for other fields
    return (
      fieldName
        // Add space before uppercase letters (for camelCase/PascalCase)
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        // Handle numbers (like Base64)
        .replace(/([a-zA-Z])(\d)/g, '$1 $2')
        .replace(/(\d)([a-zA-Z])/g, '$1 $2')
        // Convert to title case
        .replace(/\b\w/g, (l) => l.toUpperCase())
    );
  }
}
